import React, { Component } from "react";

import { Form } from "react-bootstrap";

import DatePicker, { registerLocale } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import thLocale from "date-fns/locale/th";

import { format } from "date-fns";

dayjs.extend(buddhistEra);
registerLocale("th", thLocale);

class CommonDatePicker extends Component {

    handleChange = (date, e, element) => {
        if (this.props.callback) {
            const formattedDate = date ? format(date, "yyyy-MM-dd") : null;
            e.target.value = formattedDate;
            this.props.callback(e, element);            
        }
    };

    formatDateToBE = (date) => {
        return date ? dayjs(date).add(543, "year").format("DD/MM/YYYY") : "";
    };

    parseCEtoDate = (dateString) => {
        if (!dateString) { return null; }
        return new Date(dateString);
    };

    render() {
        
        let props = this.props;

        let { onInputChange } = props;

        let { type, id, label, value, placeholder, validator, error} = props?.input;

        let { element, callback , disabled = false, hr = false, floatingLabel = true, size = "md" } = props;

        return (
            <>
                {element === 'Inputs' && floatingLabel === true && (
                    <div className="mb-0">
                        <Form.Label className={size === 'sm' ? 'label-size-sm' : ''}>{label} {validator.required && (<>*</>)}</Form.Label>
                    </div>
                )}

                <Form.Group className="datepicker-container">
                    <DatePicker
                        selected={this.parseCEtoDate(value)}
                        onChange={(date, e) => this.handleChange(date, {target: {type: 'text', id: id, name: id} }, element)}
                        dateFormat="dd/MM/yyyy"
                        locale="th"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        portalId="root-portal"
                        container="body"
                        isClearable 
                        customInput={
                            <Form.Control isInvalid={error?.status} size={size} />
                        }
                        disabled={disabled}
                        renderCustomHeader={({ date, changeYear, changeMonth }) => (
                            <div className="d-flex justify-content-center px-2">
                                <select
                                    className="form-select mx-1 compact-dropdown"
                                    value={date.getMonth()}
                                    onChange={(e) => changeMonth(parseInt(e.target.value))}
                                >
                                    {Array.from({ length: 12 }, (_, i) => (
                                        <option key={i} value={i}>
                                            {format(new Date(0, i), "MMMM", { locale: thLocale })}
                                        </option>
                                    ))}
                                </select>

                                <select
                                    className="form-select mx-1 compact-dropdown"
                                    value={date.getFullYear()}
                                    onChange={(e) => changeYear(parseInt(e.target.value))}
                                >
                                    {Array.from({ length: 101 }, (_, i) => {
                                        const yearCE = new Date().getFullYear() - 50 + i;
                                        const yearBE = yearCE + 543;
                                        return (
                                            <option key={yearCE} value={yearCE}>
                                                {yearBE}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}
                        value={this.formatDateToBE(this.parseCEtoDate(value))}
                    />

                    {(element === 'Inputs' && error?.status) && (
                        <div className="invalid-feedback d-block mt-2 ms-2" style={{fontSize: '0.75rem'}}>
                            <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-1" />
                            {error?.msg}
                        </div> 
                    )}
                </Form.Group>

                {hr && (<hr className="hr-custom" />)}
            </>
        );
    }
}

export default CommonDatePicker;
